import * as React from 'react';
import { connect } from 'react-redux';
import { Breadcrumbs } from '../../components/Breadcrumbs/Breadcrumbs';
import { PriceWithDiscount } from '../../components/Recommendation/PriceWithDiscount';
import { config } from '../../config';
import { IState } from '../../reducers';
import { IPageDataReducer } from '../../reducers/pageData';
import { IThemeOverviewPageReducer } from '../../reducers/themeOverviewPage';
import { eventTracker } from '../../helpers/EventTracker/EventTracker';
import { FurtherInfo } from '../../components/FurtherInfo/FurtherInfo';

interface StateProps {
    pageData: IPageDataReducer;
    themeOverviewPage: IThemeOverviewPageReducer;
}

type Props = StateProps;

class ThemeOverviewPageClass extends React.Component<Props, {}> {
    handleCardClick = (pageName: string, title: string) => {
        eventTracker.trackG4Event('cruise_line_specials', {
            page_type: pageName,
            event_type: 'click',
            special_name: title,
        });
    };

    render() {
        const { themeOverviewPage } = this.props;
        const { pageData, themeData, breadcrumbs, seo } = themeOverviewPage;

        const headerImage =
            pageData.headerImage || `${config.images}/common/faq_contact_background.jpg`;

        return (
            <div className="theme-overview-page">
                <div
                    className="theme-overview-page--wrapper"
                    style={{ backgroundImage: `url(${headerImage}` }}
                >
                    <div className="theme-overview-page--overlay" />
                    <div className="theme-overview-page--header-data">
                        <h1 className="roundtrip-responsive">{pageData.headerTitle}</h1>
                        <div dangerouslySetInnerHTML={{ __html: pageData.headerDescription }} />
                    </div>
                </div>
                <div className="theme-overview-page--content theme-overview-page--margin-top">
                    <div className="theme-overview-page--teasers-wrapper">
                        {themeData.map((item, index) => (
                            <div className="recommendation-teaser" key={index}>
                                <a
                                    href={item.uri}
                                    onClick={(e) =>
                                        this.handleCardClick(pageData.headerTitle, item.title)
                                    }
                                >
                                    <div className="recommendation-teaser--top">
                                        <img src={item.image} alt="" />
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: item.title,
                                            }}
                                        />
                                    </div>
                                    <div className="recommendation-teaser--bottom">
                                        <div className="recommendation-teaser--bottom__description">
                                            <div
                                                className="responsive-overflow--multi-line no-margin-on-children"
                                                dangerouslySetInnerHTML={{
                                                    __html: item.description,
                                                }}
                                            />
                                        </div>
                                        <div className="recommendation-teaser--bottom__price">
                                            <PriceWithDiscount
                                                {...{
                                                    price: item.price,
                                                    discount: item.discount,
                                                    currency: this.props.pageData.appConfig
                                                        .defaultCurrency,
                                                    discountThreshold: this.props.pageData
                                                        .discountThreshold,
                                                    hasPP: true,
                                                }}
                                            />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        ))}
                        {/* To make sure the last line is aligned left */}
                        <span className="recommendation-teaser" />
                        <span className="recommendation-teaser" />
                    </div>
                    {!!seo?.text && (
                        <div className="theme-overview-page--seotext">
                            <FurtherInfo description={seo?.text} />
                        </div>
                    )}
                </div>

                <div className="theme-overview-page--breadcrumbs">
                    <Breadcrumbs breadcrumbs={breadcrumbs} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IState) => ({
    pageData: state.pageData,
    themeOverviewPage: state.themeOverviewPage,
});

export const ThemeOverviewPage = connect(mapStateToProps)(ThemeOverviewPageClass);
export default ThemeOverviewPage;
